export const DEFAULT_ACTION_TYPE = 'inapp';
export const INAPP_ACTION = 'inapp';
export const NAVIGATOR_ACTION = 'navigator';



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/link/constants.js